import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { currentPath } from "@faire/web--source/common/Path";
import { Storage } from "@faire/web--source/common/Storage";

export const hardRefresh = (appName: string, fallbackPath: string) => {
  const HARD_REFRESH_TRACKER = `${appName}_hardRefresh`;
  const FIVE_SECONDS = 5 * 1000; // This is 100% arbitrary
  const DELIMITER = "|";

  const hardRefreshStorageValue = Storage.session.getItem(HARD_REFRESH_TRACKER);
  const path = currentPath().pathname;
  const trackingString = (date: number) => [path, date].join(DELIMITER);

  if (hardRefreshStorageValue) {
    const [storedPath, storedDate] = hardRefreshStorageValue.split(DELIMITER);

    const timeDifference = Date.now() - parseInt(storedDate ?? "0");
    if (path === storedPath && timeDifference < FIVE_SECONDS) {
      getLocation()?.replace(fallbackPath);
      return null;
    }
  }

  Storage.session.setItem(HARD_REFRESH_TRACKER, trackingString(Date.now()));
  getLocation()?.reload();
  return null;
};
